import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVerifiedTick = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M6.50525 0.578436C5.45408 0.238154 4.31136 0.711479 3.80867 1.6954L3.20433 2.87828C3.13253 3.01883 3.01822 3.13314 2.87767 3.20494L1.69479 3.80928C0.710868 4.31197 0.237543 5.45469 0.577826 6.50586L0.986921 7.76961C1.03553 7.91976 1.03553 8.08146 0.986921 8.23161L0.577826 9.49536C0.237543 10.5466 0.710868 11.6893 1.69479 12.192L2.87767 12.7963C3.01822 12.8681 3.13253 12.9824 3.20433 13.123L3.80867 14.3059C4.31136 15.2898 5.45408 15.7631 6.50525 15.4228L7.769 15.0137C7.91915 14.9651 8.08085 14.9651 8.231 15.0137L9.49475 15.4228C10.5459 15.7631 11.6886 15.2898 12.1914 14.3059L12.7956 13.123C12.8675 12.9824 12.9818 12.8681 13.1223 12.7963L14.3052 12.192C15.2892 11.6893 15.7625 10.5466 15.4222 9.49536L15.0131 8.23161C14.9645 8.08146 14.9645 7.91976 15.0131 7.76961L15.4222 6.50586C15.7625 5.45469 15.2892 4.31197 14.3052 3.80928L13.1223 3.20494C12.9818 3.13314 12.8675 3.01883 12.7956 2.87828L12.1914 1.6954C11.6886 0.711479 10.5459 0.238154 9.49475 0.578436L8.231 0.987531C8.08085 1.03613 7.91915 1.03614 7.769 0.987531L6.50525 0.578436ZM4.06983 7.81858L5.13049 6.75786L7.2518 8.87923L11.4945 4.6366L12.5551 5.69725L7.2518 11.0005L4.06983 7.81858Z",
		fill: "#003399"
	})]
});
const ForwardRef = forwardRef(SvgVerifiedTick);
export { ForwardRef as ReactComponent };
